/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconWorldDownload = createReactComponent("world-download", "IconWorldDownload", [
  ["path", { d: "M21 12a9 9 0 1 0 -9 9", key: "svg-0" }],
  ["path", { d: "M3.6 9h16.8", key: "svg-1" }],
  ["path", { d: "M3.6 15h8.4", key: "svg-2" }],
  ["path", { d: "M11.578 3a17 17 0 0 0 0 18", key: "svg-3" }],
  ["path", { d: "M12.5 3c1.719 2.755 2.5 5.876 2.5 9", key: "svg-4" }],
  ["path", { d: "M18 14v7m-3 -3l3 3l3 -3", key: "svg-5" }]
]);

export { IconWorldDownload as default };
//# sourceMappingURL=IconWorldDownload.js.map
